import { render, staticRenderFns } from "./BaseInputInteger.vue?vue&type=template&id=4548c46b"
import script from "./BaseInputInteger.vue?vue&type=script&lang=js"
export * from "./BaseInputInteger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports